import { dataHooks } from '@wix/data-hooks'

export const wixVibeMobileSplitDataHooks = dataHooks<{
  title: {}
  description: {}
  option: { key: string; lable: string }
  next: {}
  skip: {}
}>('wix-vibe-mobile-split')
